import { useState } from "react";

const navLinks = [
  { label: "合集索引", href: "#collections" },
  { label: "快讯流", href: "#stream" },
  { label: "封面墙", href: "#covers" },
  { label: "浏览指引", href: "#guide" },
  { label: "常见问题", href: "#faq" },
];

export default function SiteHeader() {
  const [menuOpen, setMenuOpen] = useState(false);

  return (
    <header className="sticky top-0 z-40 w-full border-b border-background-200/70 bg-background-50/85 backdrop-blur-md">
      <div className="mx-auto flex h-16 w-full max-w-[1400px] items-center justify-between gap-4 px-4 md:px-6">
        <a href="#top" className="group flex items-center gap-3">
          <span className="flex h-10 w-10 items-center justify-center rounded-md bg-primary-500 text-background-50 transition-transform duration-300 group-hover:-rotate-6">
            <i className="ri-camera-lens-line text-xl" />
          </span>
          <span className="flex flex-col leading-none">
            <h1 className="font-heading text-xl font-bold tracking-wide text-foreground-950">
              私拍吃瓜
            </h1>
            <span className="mt-1 text-[10px] tracking-[0.34em] text-secondary-500">
              ONSITE ARCHIVE
            </span>
          </span>
        </a>

        <nav className="hidden items-center gap-1 md:flex">
          {navLinks.map((link) => (
            <a
              key={link.href}
              href={link.href}
              className="cursor-pointer whitespace-nowrap rounded-md px-3 py-2 text-sm text-foreground-700 transition-colors duration-200 hover:bg-background-100 hover:text-foreground-950"
            >
              {link.label}
            </a>
          ))}
        </nav>

        <div className="flex items-center gap-2">
          <a
            href="#stream"
            className="hidden cursor-pointer items-center gap-2 whitespace-nowrap rounded-md bg-accent-500 px-4 py-2.5 text-sm font-medium text-background-50 transition-colors duration-200 hover:bg-accent-600 md:flex"
          >
            <i className="ri-flashlight-line text-base" />
            看最新直击
          </a>
          <button
            type="button"
            aria-label="打开菜单"
            onClick={() => setMenuOpen((prev) => !prev)}
            className="flex h-10 w-10 cursor-pointer items-center justify-center rounded-md border border-background-300 text-foreground-800 transition-colors hover:bg-background-100 md:hidden"
          >
            <i className={menuOpen ? "ri-close-line text-xl" : "ri-menu-line text-xl"} />
          </button>
        </div>
      </div>

      {menuOpen && (
        <div className="border-t border-background-200 bg-background-50 px-4 pb-4 pt-2 md:hidden">
          <nav className="flex flex-col">
            {navLinks.map((link) => (
              <a
                key={link.href}
                href={link.href}
                onClick={() => setMenuOpen(false)}
                className="cursor-pointer border-b border-background-100 py-3 text-sm text-foreground-800 last:border-b-0"
              >
                {link.label}
              </a>
            ))}
          </nav>
          <a
            href="#stream"
            onClick={() => setMenuOpen(false)}
            className="mt-3 flex w-full items-center justify-center gap-2 rounded-md bg-accent-500 px-4 py-3 text-sm font-medium text-background-50"
          >
            <i className="ri-flashlight-line text-base" />
            看最新直击
          </a>
        </div>
      )}
    </header>
  );
}